module.exports = __webpack_public_path__ + "static/media/wifIcon.5a15ef7d.svg";